import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges
} from '@angular/core';
import type { DeadlineDelayRequestFormInterface } from '@zaoblako/shared/modules/project/dto/deadline-delay-request/deadline-delay-request-form.dto';
import type { ProjectFindInterface } from '@zaoblako/shared/modules/project/dto/project/project-find.dto';
import { ProjectService } from '@zaoblako/web/core/services/project/project.service';
import { AuthService } from '@zaoblako/web/core/services/security/auth.service';
import { ProjectStoreService } from '@zaoblako/web/modules/project/components/project/card/services/project-store.service';
import { ProjectChangeDeadlineFormOverlayPanelComponent } from '@zaoblako/web/modules/project/dumbs/project-change-deadline-form-overlay-panel/project-change-deadline-form-overlay-panel.component';
import { DatepickerComponent } from '@zaoblako/web/shared/dumbs/datepicker/datepicker.component';
import { SafeHtmlPipe } from '@zaoblako/web/shared/pipes/safe-html.pipe';
import { TruncatePipe } from '@zaoblako/web/shared/pipes/truncate.pipe';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  standalone: true,
  selector: 'crm-project-change-deadline',
  templateUrl: './project-change-deadline.component.html',
  imports: [
    CommonModule,
    DatepickerComponent,
    TooltipModule,
    TruncatePipe,
    SafeHtmlPipe,
    ProjectChangeDeadlineFormOverlayPanelComponent
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProjectChangeDeadlineComponent implements OnInit, OnChanges {
  @Input() public project: ProjectFindInterface;
  public loading = false;

  @Input() public isTextRight = false;

  public formDeadline = <DeadlineDelayRequestFormInterface>{};

  public isCreator = false;
  public isResponsible = false;

  public constructor(
    private readonly authService: AuthService,
    private readonly projectService: ProjectService,
    private readonly projectStoreService: ProjectStoreService,
    private readonly cdRef: ChangeDetectorRef
  ) {}

  public ngOnInit(): void {
    this.isCreator = this.authService.currentUser?.id === this.project?.creator?.id;
    this.isResponsible = this.authService.currentUser?.id === this.project?.responsible?.id;
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.project?.currentValue && this.project.deadlineDelayRequest) {
      this.formDeadline = {
        deadline: this.project.deadlineDelayRequest?.deadline,
        commentary: this.project.deadlineDelayRequest?.commentary
      };
    }
  }

  public acceptNewDate() {
    this.loading = true;
    this.cdRef.markForCheck();

    this.projectService.acceptDeadline(this.project?.id, this.formDeadline).subscribe({
      next: () => {
        const project = { ...this.projectStoreService.getProject };
        this.project.deadline = this.formDeadline.deadline;
        this.project.deadlineDelayRequest = null;
        project.deadline = this.formDeadline.deadline;
        project.deadlineDelayRequest = null;
        this.projectStoreService.setState({ project });
        this.formDeadline = <DeadlineDelayRequestFormInterface>{};
        this.loading = false;
        this.cdRef.markForCheck();
      },
      error: () => {
        this.loading = false;
        this.cdRef.markForCheck();
      }
    });
  }

  public cancelNewDate() {
    this.loading = true;
    this.cdRef.markForCheck();

    this.projectService.refuseDeadline(this.project?.id).subscribe({
      next: () => {
        const project = { ...this.projectStoreService.getProject };
        this.project.deadlineDelayRequest = null;
        project.deadlineDelayRequest = null;
        this.projectStoreService.setState({ project });
        this.formDeadline = <DeadlineDelayRequestFormInterface>{};
        this.loading = false;
        this.cdRef.markForCheck();
      },
      error: () => {
        this.loading = false;
        this.cdRef.markForCheck();
      }
    });
  }
}
